import { Routes } from '@angular/router';
import { authGuard, SPECTRUM_HELP_ROUTES } from 'common';

export const routes: Routes = [
    {
        path: 'validate',
        loadComponent: () => import('./validate/validate.component').then(m => m.ValidateComponent)
    },
    {
        // The shared Spectrum sign-in screen. It lives in `common`, so any other
        // app mounts it with this same one-line route — nothing else to provide,
        // since SPECTRUM_AUTH_API is already given in every app.config.ts.
        path: 'login',
        loadComponent: () => import('common').then(m => m.SpectrumLoginComponent)
    },
    {
        path: '',
        canActivate: [authGuard],
        loadComponent: () => import('./layout/screens.component').then(m => m.ScreensComponent),
        children: [
            // The Help centre: this module's manual and Getting around Spectrum.
            ...SPECTRUM_HELP_ROUTES,
            { path: '', redirectTo: 'overview', pathMatch: 'full' },
            {
                path: 'overview',
                loadComponent: () => import('./screens/overview/overview.component').then(m => m.OverviewComponent)
            },
            {
                path: 'profile',
                loadComponent: () => import('./screens/profile/profile.component').then(m => m.ProfileComponent)
            },
            {
                path: 'structure',
                loadComponent: () => import('./screens/structure/structure.component').then(m => m.StructureComponent)
            },
            {
                path: 'promotion',
                loadComponent: () => import('./screens/promotion/promotion.component').then(m => m.PromotionComponent)
            },
            {
                path: 'quick-setup',
                loadComponent: () => import('./screens/quick-setup/quick-setup.component').then(m => m.QuickSetupComponent)
            }
        ]
    },
    { path: '**', redirectTo: '' }
];
